export default __webpack_public_path__ + "static/media/mlc-structura.a623ef05.jpeg";